"use client"

import { useEffect } from "react"

import { initializeClientAnalyticsContext } from "@/src/lib/analytics/client"
import { bindGlobalAnalyticsListeners } from "@/src/lib/analytics/ui"

export function UIInteractionAnalytics() {
  useEffect(() => {
    initializeClientAnalyticsContext()

    return bindGlobalAnalyticsListeners()
  }, [])

  return null
}
